import React from 'react';

import { BlockAdultsWithLowAssurance } from '@components/block-adults-with-low-assurance';
import CardPinModal from '@components/card/card-info-with-functionality/card-pin/CardPinModal';
import ReopenCardErrorCardModal from '@components/card/card-info-with-functionality/functionality/reopen-card/ReopenCardErrorCardModal';
import ReopenCardModal from '@components/card/card-info-with-functionality/reopen-card/ReopenCardModal';
import VirtualCardErrorCardModal from '@components/card/card-info-with-functionality/virtual-card/VirtualCardErrorCardModal';
import VirtualCardModal from '@components/card/card-info-with-functionality/virtual-card/VirtualCardModal';
import { DigitalCardLowAssuranceWarning, OnlyNativeAllowedWarning } from '@domain/digital-wallet';
import { Card } from '@generated-types';

import { ModalState } from '../CardInfoWithFunctionality';
import ActivateCardModal from '../activate-card/ActivateCardModal';

interface ModalsProps {
    card: Card;
    modalState: ModalState;
    setModalState: (state: ModalState) => void;
}

const DigitalCard = ({ setModalState, modalState, card }: ModalsProps) => {
    const close = () => {
        setModalState({ ...modalState, showDigitalCardModal: false });
    };

    if (!card.allowedOperations.getVirtualCard) {
        return <VirtualCardErrorCardModal show={modalState.showDigitalCardModal} onClose={close} />;
    }

    if (modalState.showDigitalCardModal) {
        return (
            <BlockAdultsWithLowAssurance
                onlyNativeAllowedWarning={<OnlyNativeAllowedWarning onClose={close} />}
                lowAssuranceWarning={<DigitalCardLowAssuranceWarning onClose={close} />}
            >
                <VirtualCardModal card={card} open={modalState.showDigitalCardModal} setOpen={close} />
            </BlockAdultsWithLowAssurance>
        );
    }

    return null;
};

const ReopenCard = ({ setModalState, modalState, card }: ModalsProps) => {
    const [reopened, setReopened] = React.useState<boolean>(false);
    const close = () => {
        setModalState({ ...modalState, showReopenCardModal: false });
        setReopened(true);
    };

    if (!card.allowedOperations.unblock && reopened) {
        return <ReopenCardErrorCardModal show={modalState.showReopenCardModal} onClose={close} />;
    }

    return <ReopenCardModal card={card} show={modalState.showReopenCardModal} onClose={close} />;
};

const ActivateCard = ({ setModalState, modalState, card }: ModalsProps) => {
    const close = () => {
        setModalState({ ...modalState, showCardActivationModal: false });
    };

    if (!card.allowedOperations.activateCard) {
        return <ReopenCardErrorCardModal show={modalState.showCardActivationModal} onClose={close} />;
    }

    return <ActivateCardModal card={card} show={modalState.showCardActivationModal} onClose={close} />;
};

const Modals = ({ card, modalState, setModalState }: ModalsProps) => {
    return (
        <>
            <DigitalCard card={card} modalState={modalState} setModalState={setModalState} />
            <ActivateCard card={card} modalState={modalState} setModalState={setModalState} />
            <CardPinModal
                open={modalState.showPinModal}
                setOpen={() => setModalState({ ...modalState, showPinModal: false })}
                card={card}
            />
            <ReopenCard card={card} modalState={modalState} setModalState={setModalState} />
        </>
    );
};

export default Modals;
